const scrollToRef = (ref, blockOption, inlineOption) => {
  const options = {
    behavior: 'smooth',
    block: blockOption || 'start',
    inline: inlineOption || 'nearest'
  }

  return ref && ref.current && ref.current.scrollIntoView(options)
}

export default scrollToRef
